module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/5/2-c0ba5162aeb1fa769980be3e8f97326e.jpg";